module.exports = __webpack_public_path__ + "img/cazana.1fa09107.svg";